export default function trackShare(url: string) {
  fetch(url, {
    method: 'POST'
  }).catch(error => {
    // ReactGA.exception(error)
  })
}